import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../../../../../../../LinkyLinky';
import Modal from '../../../../../../../../../../../../../Modal';
import ModalStore from '../../../../../../../../../../../../../Modal/Store';
import { LearningCollectionPublishResource } from '../../../../../../../Store/Types';
import InviteParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Store/Types';
import Body from './Body';
import Header from './Header';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  state: SelectParticipantsState;
}

const ReadyModal: React.FC<Props> = ({
  modalStore,
  store,
  learningCollectionPublishResource,
  state,
}) =>
  findLink('options', learningCollectionPublishResource.links)
    .map((link) => (
      <Modal
        close={modalStore.close}
        title={<Header />}
        customBackgroundCssClasses="bg-teal-100 opacity-60"
        modalWidth="w-2/5"
      >
        <Body
          link={link}
          store={store}
          learningCollectionPublishResource={learningCollectionPublishResource}
          state={state}
        />
      </Modal>
    ))
    .getOrElse(emptyFragment);

export default observer(ReadyModal);
